import request from '@/utils/request'
import store from '@/store'
let BASE_URL

const role = store.getters.userInfo.roles

if(role.indexOf('试听课学生') !== -1){
	BASE_URL = '/auditionstudent'
}else{
	BASE_URL = '/formalstudent'
}

// 获取题目列表
export function getHomeworkList(params) {
	return request({
		url: BASE_URL + '/homework_item_list',
		method: 'get',
		params
	})
}

// 获取题目详情
export function getHomeworkInfo(params) {
	return request({
		url: BASE_URL + '/homework_item_info',
		method: 'get',
		params
	})
}

// 获取题目结果
export function getHomeworkResult(params) {
	return request({
		url: BASE_URL + '/homework_item_result',
		method: 'get',
		isLoading: false,
		params
	})
}

// 提交代码
export function commitHomeworkResult(data) {
	return request({
		url: BASE_URL + '/commit_homework_item_result',
		method: 'post',
		data
	})
}

export function formatCode(params) {
	return request({
		url: '/format_code',
		method: 'get',
		params
	})
}
